import styled from "@emotion/styled"

const CertificationModalWrapper = styled.div`
  position: relative;
`

export default CertificationModalWrapper
